import {
  EnumAlarmType,
  EnumNotificationType,
  EnumTempDeterminer,
} from "../../redux/interfaces";

export const KatalogEvidencijaResourcesDE: KatalogEvidencijaResourcesBSInterface =
  {
    deleteModal: {
      title: "Evidenz löschen",
      text: "Möchten Sie diese Evidenz löschen?",
      buttonYes: "Löschen",
      buttonNo: "Zurück",
    },
    deleteSuccessModal: {
      title: "Erfolgreich gelöscht",
      body: "Die Evidenz wurde erfolgreich gelöscht.",
      buttonOk: "OK",
    },
    deleteErrorModal: {
      title: "Fehler beim Löschen",
      body: "Beim Löschen der Evidenz ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie den Administrator.",
      buttonOk: "OK",
    },
    checklistConfig: {
      title: "Checklist Konfiguration",
      rowLabel: "Checklist Konfiguration",
      rowPlaceholder: "Namen der Checklist-Elemente definieren",
      fieldLabelPrefix: "Elementname #",
      checkedByDefaultLabel: "Standardmäßig aktivieren",
      addButton: "Element hinzufügen",
      removeButton: "Entfernen",
      buttons: {
        save: "Speichern",
        back: "Zurück",
      },
      errors: {
        load: "Fehler beim Laden.",
        save: "Fehler beim Speichern.",
      },
    },
    errors: {
      poslovnica: "Bitte wählen Sie eine Filiale aus.",
      katalogEvidencijaBranches:
        "Fehler beim Laden. Bitte kontaktieren Sie den Administrator.",
      deleteError:
        "Beim Löschen der Konfiguration ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Administrator.",
    },
    successModal: {
      title: "Dateneingabe",
      body: "Das Hinzufügen von Daten wurde erfolgreich abgeschlossen. Wählen Sie OK zum Fortfahren.",
      buttonOk: "OK",
    },
    editDescription: {
      title: "Beschreibungsbearbeitung",
    },
    addButton: "Neu hinzufügen",
    evidencijePlaceholder: "Keine Nachweise gefunden",
    evidencijeOdabirPoslovnice: "Filiale auswählen",
    typeEvidencije: {
      occasionally: "Bei Bedarf",
      redovna: "Regelmäßig",
      placeholder: "Bitte wählen Sie eine Kategorie",
    },
    vrsteEvidencije: {
      evidencija: "Nachweis",
      template: "Vorlage",
    },
    evidencijaForm: {
      title: "Nachweis-Katalog Formular",
      markdownContent: {
        name: "markdownContent",
        error: "Fehler Markdown-Inhalt",
        label: "Detaillierte Beschreibung",
        placeholder: "",
      },
      branch: {
        label: "Filiale auswählen",
        placeholder: "Filiale auswählen",
        noOptions: "Keine Filialen gefunden",
        name: "branch",
        error: "",
      },
      typeList: {
        label: "Kategorie auswählen",
        placeholder: "Kategorie auswählen",
        noOptions: "Keine Kategorien gefunden",
        name: "typeList",
        error: "",
      },
      revizija: {
        label: "Revision",
        placeholder: "Revisionsversion hinzufügen",
        name: "revizija",
        error: "Revisionsversion hinzufügen",
      },
      description: {
        label: "Beschreibung",
        placeholder: "Beschreibung hinzufügen",
        name: "description",
        error: "Beschreibung hinzufügen",
      },
      titleForm: {
        label: "Nachweisname",
        placeholder: "Nachweisname hinzufügen",
        name: "title",
        error: "Nachweisname hinzufügen",
      },
      category: {
        label: "Nachweistyp auswählen",
        placeholder: "Typ auswählen",
        noOptions: "Keine Typen gefunden",
        name: "category",
        error: "",
      },
      buttonForward: "Hinzufügen",
      buttonBack: "Zurück",
      successModal: {
        title: "Dateneingabe",
        body: "Das Hinzufügen von Daten wurde erfolgreich abgeschlossen. Wählen Sie OK zum Fortfahren.",
        buttonOk: "OK",
      },
    },
    autocompleteConfig: {
      title: "Automatische Ausfüll-Konfiguration",
      enabled: {
        label: "Automatisches Ausfüllen aktivieren",
        name: "enabled",
      },
      signerType: {
        label: "Unterzeichner-Typ",
        name: "signerType",
        options: {
          user: "Spezifischer Benutzer",
          position: "Position/Rolle",
        },
        note: "Das Ändern des Unterzeichner-Typs löscht nur die aktuelle Unterzeichnerauswahl für die Autovervollständigung, hat aber keinen Einfluss auf verantwortliche Personen.",
      },
      signer: {
        label: "Unterzeichner",
        name: "signer",
        placeholder: "Benutzer-ID oder Position eingeben",
      },
      fieldValues: {
        title: "Feldwerte-Konfiguration",
        description:
          "Konfigurieren Sie Werte für bestimmte Felder. Verwenden Sie Semikolon (;) zur Trennung mehrerer Werte für zufällige Auswahl.",
        fieldName: {
          label: "Feldname",
          placeholder: "Feld auswählen",
        },
        values: {
          label: "Werte (mit ; trennen)",
          placeholder: "wert1; wert2; wert3",
        },
        addButton: "Feldwert hinzufügen",
        removeButton: "Entfernen",
      },
      pointScope: {
        label: "Anwendungspunkt",
        allPoints: "Alle Anwendungspunkte",
        hintAll:
          "Diese Werte gelten für alle Anwendungspunkte, außer denen mit speziellem Override.",
        hintPoint:
          "Werte nur für den ausgewählten Anwendungspunkt. Andere Punkte nutzen die Einstellungen von „Alle Anwendungspunkte“.",
        hasOverride: "Eigene Einstellungen",
        clearOverride: "Auf gemeinsame Einstellungen zurücksetzen",
        noPoints:
          "Keine Anwendungspunkte konfiguriert. Bitte zuerst im Schritt Anwendungspunkte hinzufügen.",
      },
      successModal: {
        title: "Erfolgreich!",
        body: "Die automatische Ausfüll-Konfiguration wurde erfolgreich gespeichert.",
        buttonOk: "OK",
      },
      buttons: {
        save: "Konfiguration speichern",
        back: "Zurück",
      },
    },
    kreiranjeEvidencije: {
      errorMissingFields:
        "Bitte füllen Sie alle Felder aus, um den Nachweis zu aktivieren.",
      errorCreation:
        "Ein Fehler ist aufgetreten. Bitte kontaktieren Sie den Administrator.",
      description: {
        label: "Beschreibungen",
        placeholder: "Beschreibung eingeben",
        name: "opis",
        error: "",
      },
      tempConfigPolja: {
        name: "tempConfig",
        label: "Temperatur-Konfiguration",
        placeholder: "Bitte geben Sie die Temperatur-Konfiguration ein",
        title: "Temperatur-Konfiguration",
        dozvoljenaTempMin: {
          label: "Minimal erlaubte Temperatur",
          name: "dozvoljenaTempMin",
          placeholder: "Bitte geben Sie die Mindesttemperatur ein",
        },
        dozvoljenaTempMax: {
          label: "Maximal erlaubte Temperatur",
          name: "dozvoljenaTempMax",
          placeholder: "Bitte geben Sie die Höchsttemperatur ein",
        },
        dozvoljenoOdstupanje: {
          label: "Erlaubte Abweichung",
          name: "dozvoljenoOdstupanje",
          placeholder: "Bitte geben Sie die erlaubte Abweichung ein",
        },
      },
      status: {
        activate: "Aktivieren",
        deactivate: "Deaktivieren",
        saveAs: "Neue Version",
      },
      nazivEvidencije: {
        title: "Nachweis erstellen",
        label: "Nachweisname",
        placeholder: "Nachweisname hinzufügen",
        name: "title",
        error: "Nachweisname hinzufügen",
      },
      revizija: {
        title: "Revision",
        label: "Revision",
        placeholder: "Revision hinzufügen",
        name: "revizija",
        error: "Revision hinzufügen",
      },
      tackePrimjene: {
        title: "Anwendungspunkte",
        label: "Anwendungspunkte",
        placeholder: "Anwendungspunkte auswählen",
        name: "recordPoints",
        error: "Kein Anwendungspunkt ausgewählt",
      },
      ucestalost: {
        title: "Aufzeichnungsfrequenz",
        label: "Aufzeichnungsfrequenz",
        placeholder: "Aufzeichnungsfrequenz eingeben",
        name: "frequency",
        error: "Aufzeichnungsfrequenz nicht ausgewählt",
        visegodisnje: {
          title: "Mehrjährig",
          btnVisegodisnje: "Mehrjährig",
          btnDatum: "Datum",
        },
        godisnje: {
          title: "Jährlich",
          btnGodisnje: "Jährlich",
          btnDatum: "Datum",
        },
        mjesecno: {
          title: "Monatlich",
          btnMjesecno: "Monatlich",
          btnDatumPocetak: "Startdatum",
          btnDatumKraj: "Enddatum",
          btnBrojanje: "Beginn ab",
          lblSvaki: "Jeden ",
          lblMjesec: "Monat",
        },
        sedmicno: {
          title: "Wöchentlich",
          btnSedmicno: "Wöchentlich",
          btnDatumPocetak: "Startdatum",
          btnDatumKraj: "Enddatum",
          btnBrojanje: "Beginn ab",
          lblSvake: "Jede ",
          lblSedmice: "Wochen",
          errorBeginDate: "Wählen Sie eine Woche (YYYY-Www) vor dem Speichern.",
        },
        dnevno: {
          title: "Täglich",
          btnDnevno: "Täglich",
          btnPocetak: "Start",
          btnKraj: "Ende",
          btnBrojanje: "Beginn ab",
          lblSvaki: "Jeden ",
          lblDan: "Tag",
          skipSaturday: "Samstag überspringen",
          skipSunday: "Sonntag überspringen",
        },
        poPotrebi: {
          btnPoPotrebi: "Bei Bedarf",
        },
      },
      odgovorneOsobe: {
        title: "Verantwortliche Personen",
        label: "Verantwortliche Personen",
        placeholder: "Verantwortliche Personen auswählen",
        name: "dedicatedUsers",
        error: "Keine verantwortliche Person ausgewählt",
      },
      tpEvidencije: {
        title: "Anwendungspunkte",
        back: "Zurück",
        next: "Änderungen speichern",
      },
      podsjetnik: {
        title: "Benachrichtigungen",
        label: "Benachrichtigungen",
        placeholder: "Benachrichtigungen konfigurieren",
        name: "notifications",
        error: "Benachrichtigungen nicht konfiguriert",
      },
      poljeEvidencije: {
        title: "Nachweisfelder",
        label: "Nachweisfelder",
        placeholder: "Nachweisfelder auswählen",
        name: "poljeEvidencije",
        error: "Nachweisfelder nicht ausgewählt",
      },
      obavijesti: {
        title: "Benachrichtigungen",
        cbNotifikacija: "Bei Ablauf - Benachrichtigung",
        plcPeriod: "Zeitraum",
        optPeriod: [
          {
            value: EnumTempDeterminer.MINUTA,
            label: "Minuten",
          },
          {
            value: EnumTempDeterminer.SATI,
            label: "Stunden",
          },
          {
            value: EnumTempDeterminer.DANA,
            label: "Tage",
          },
        ],
        plcKada: "Vorher/nachher",
        optKada: [
          {
            value: EnumAlarmType.beforeStart,
            label: "Vor Beginn",
          },
          {
            value: EnumAlarmType.afterStart,
            label: "Nach Beginn",
          },
          {
            value: EnumAlarmType.beforeEnd,
            label: "Vor Ablauf",
          },
          {
            value: EnumAlarmType.afterEnd,
            label: "Nach Ablauf",
          },
        ],
        plcKako: "Benachrichtigung",
        optKako: [
          {
            value: EnumNotificationType.email1,
            label: "E-Mail an zugewiesene Personen",
          },
          {
            value: EnumNotificationType.email2,
            label: "E-Mail an Manager",
          },
          {
            value: EnumNotificationType.email3,
            label: "E-Mail an Vorgesetzte",
          },
          {
            value: EnumNotificationType.sms1,
            label: "SMS an zugewiesene Personen",
          },
          {
            value: EnumNotificationType.sms2,
            label: "SMS an Manager",
          },
          {
            value: EnumNotificationType.sms3,
            label: "SMS an Vorgesetzte",
          },
          {
            value: EnumNotificationType.call1,
            label: "Anruf an zugewiesene Personen",
          },
          {
            value: EnumNotificationType.call2,
            label: "Anruf an Manager",
          },
          {
            value: EnumNotificationType.call3,
            label: "Anruf an Vorgesetzte",
          },
        ],
      },
      language: {
        title: "Sprache",
        label: "Sprache",
        placeholder: "Sprache auswählen",
        name: "language",
        options: {
          bs: "Bosnisch",
          en: "Englisch",
          de: "Deutsch",
        },
      },
      manager: {
        label: "Manager",
        placeholder: "Manager auswählen",
        notFound: "Keine Benutzer gefunden",
      },
      isPublic: {
        title: "Öffentlicher Zugang",
        label: "Evidenz ist öffentlich",
        description: "Wenn angehakt, ist die Evidenz öffentlich verfügbar",
      },
      notifyManagersOnFeedback: {
        title: "Manager benachrichtigen",
        label: "Manager per E-Mail über neues Feedback informieren",
        description:
          "Wenn angehakt, erhalten Filialmanager bei jedem neuen Feedback eine E-Mail",
      },
      qrCode: {
        button: "QR-Code generieren",
        modalTitle: "QR-Code generieren",
        selectLabel: "Aufzeichnungspunkt auswählen",
        selectPlaceholder: "Aufzeichnungspunkt auswählen...",
        generateButton: "QR-Code generieren",
        downloadButton: "QR-Code herunterladen",
        cancelButton: "Abbrechen",
        noRecordPointsError: "Keine Aufzeichnungspunkte konfiguriert. Bitte konfigurieren Sie zuerst Aufzeichnungspunkte.",
        downloadError: "Beim Herunterladen des QR-Codes ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
      },
      details: {
        title: "Details",
        recordPointIds: "Aufzeichnungspunkt-IDs",
        noRecordPoints: "Aufzeichnungspunkte wurden noch nicht generiert",
      },
      buttonForward: "Weiter",
      buttonBack: "Zurück",
      successModal: {
        title: "Dateneingabe",
        body: "Das Hinzufügen von Daten wurde erfolgreich abgeschlossen. Wählen Sie OK zum Fortfahren.",
        buttonOk: "OK",
      },
    },
    recordPointsConfig: {
      title: "Anwendungspunkte-Konfiguration",
      errorMissingFields:
        "Bitte füllen Sie alle Felder aus, um den Nachweis zu aktivieren.",
      errorCreation:
        "Ein Fehler ist aufgetreten. Bitte kontaktieren Sie den Administrator.",
      recordPoints: {
        title: "Anwendungspunkte",
        label: "Anwendungspunkte",
        placeholder: "Anwendungspunkte eingeben",
        name: "recordPoints",
        error: "Anwendungspunkte nicht eingegeben",
        addButton: "Punkt hinzufügen",
        removeButton: "Entfernen",
        selectedLabel: "Ausgewählt",
        notSelectedLabel: "Nicht ausgewählt",
      },
      buttonForward: "Weiter",
      buttonBack: "Zurück",
      successModal: {
        title: "Dateneingabe",
        body: "Das Hinzufügen von Daten wurde erfolgreich abgeschlossen. Wählen Sie OK zum Fortfahren.",
        buttonOk: "OK",
      },
    },
    frequencyConfig: {
      title: "Frequenz-Konfiguration",
      errorMissingFields:
        "Bitte füllen Sie alle Felder aus, um den Nachweis zu aktivieren.",
      errorCreation:
        "Ein Fehler ist aufgetreten. Bitte kontaktieren Sie den Administrator.",
      frequency: {
        title: "Frequenz",
        label: "Frequenz",
        placeholder: "Frequenz eingeben",
        name: "frequency",
        error: "Frequenz nicht eingegeben",
        addButton: "Frequenz hinzufügen",
        removeButton: "Entfernen",
        typeLabel: "Typ",
        startDateLabel: "Startdatum",
        endDateLabel: "Enddatum",
        occurrenceLabel: "Auftreten",
        beginDateLabel: "Beginndatum",
        types: {
          DNEVNI: "Täglich",
          SEDMICNI: "Wöchentlich",
          MJESECNI: "Monatlich",
          GODISNJI: "Jährlich",
          CUSTOM: "Benutzerdefiniert",
        },
      },
      buttonForward: "Weiter",
      buttonBack: "Zurück",
      successModal: {
        title: "Dateneingabe",
        body: "Das Hinzufügen von Daten wurde erfolgreich abgeschlossen. Wählen Sie OK zum Fortfahren.",
        buttonOk: "OK",
      },
    },
    usersConfig: {
      title: "Benutzer-Konfiguration",
      errorMissingFields:
        "Bitte füllen Sie alle Felder aus, um den Nachweis zu aktivieren.",
      errorCreation:
        "Ein Fehler ist aufgetreten. Bitte kontaktieren Sie den Administrator.",
      users: {
        title: "Benutzer",
        label: "Benutzer",
        placeholder: "Benutzer eingeben",
        name: "users",
        error: "Benutzer nicht eingegeben",
        addButton: "Benutzer hinzufügen",
        removeButton: "Entfernen",
        recordPointLabel: "Benutzer/Position",
        categoryLabel: "Ist Position",
        categoryOptions: {
          user: "Benutzer",
          position: "Position",
        },
      },
      buttonForward: "Weiter",
      buttonBack: "Zurück",
      successModal: {
        title: "Dateneingabe",
        body: "Das Hinzufügen von Daten wurde erfolgreich abgeschlossen. Wählen Sie OK zum Fortfahren.",
        buttonOk: "OK",
      },
    },
    notificationsConfig: {
      title: "Benachrichtigungs-Konfiguration",
      errorMissingFields:
        "Bitte füllen Sie alle Felder aus, um den Nachweis zu aktivieren.",
      errorCreation:
        "Ein Fehler ist aufgetreten. Bitte kontaktieren Sie den Administrator.",
      notifications: {
        title: "Benachrichtigungen",
        label: "Benachrichtigungen",
        placeholder: "Benachrichtigungen konfigurieren",
        name: "notifications",
        error: "Benachrichtigungen nicht konfiguriert",
        defaultNotification: {
          label: "Standard-Benachrichtigung",
          name: "defaultNotification",
        },
        addButton: "Benachrichtigung hinzufügen",
        removeButton: "Entfernen",
        typeLabel: "Typ",
        alarmTypeLabel: "Alarm-Typ",
        tempDeterminerLabel: "Temperatur-Bestimmer",
        countdownLabel: "Countdown",
        types: {
          [EnumNotificationType.email1]: "E-Mail 1",
          [EnumNotificationType.email2]: "E-Mail 2",
          [EnumNotificationType.email3]: "E-Mail 3",
          [EnumNotificationType.sms1]: "SMS 1",
          [EnumNotificationType.sms2]: "SMS 2",
          [EnumNotificationType.sms3]: "SMS 3",
          [EnumNotificationType.call1]: "Anruf 1",
          [EnumNotificationType.call2]: "Anruf 2",
          [EnumNotificationType.call3]: "Anruf 3",
        },
        alarmTypes: {
          [EnumAlarmType.beforeStart]: "Vor Start",
          [EnumAlarmType.afterStart]: "Nach Start",
          [EnumAlarmType.beforeEnd]: "Vor Ende",
          [EnumAlarmType.afterEnd]: "Nach Ende",
        },
        tempDeterminers: {
          [EnumTempDeterminer.DANA]: "Tage",
          [EnumTempDeterminer.MINUTA]: "Minuten",
          [EnumTempDeterminer.SATI]: "Stunden",
        },
      },
      buttonForward: "Weiter",
      buttonBack: "Zurück",
      successModal: {
        title: "Dateneingabe",
        body: "Das Hinzufügen von Daten wurde erfolgreich abgeschlossen. Wählen Sie OK zum Fortfahren.",
        buttonOk: "OK",
      },
    },
    evidenceFieldsConfig: {
      title: "Nachweisfelder-Konfiguration",
      errorMissingFields:
        "Bitte füllen Sie alle Felder aus, um den Nachweis zu aktivieren.",
      errorCreation:
        "Ein Fehler ist aufgetreten. Bitte kontaktieren Sie den Administrator.",
      recordFields: {
        title: "Nachweisfelder",
        label: "Nachweisfelder",
        placeholder: "Nachweisfelder auswählen",
        name: "recordFields",
        error: "Nachweisfelder nicht ausgewählt",
        options: {
          CIPP_V1: "Reinigung und Waschen von Räumlichkeiten",
          CIPO_V1: "Reinigung und Waschen von Geräten",
          TemperaturaEvd_V1: "Temperaturlisten v1",
          TemperaturaOgranicenaEvd_V1: "Temperaturlisten - Begrenzt",
          TemperaturaOgranicenaKKTEvd_V1: "Temperaturlisten - Begrenzt KKT",
          TemperaturaKKTProizvodiEvd_V1:
            "Temperaturlisten - Begrenzt KKT Produkte",
          Dezinfekcija_V1: "Desinfektion v1",
          Dezinsekcija_V1: "Desinsektierung v1",
          Deratizacija_V1: "Deratisierung v1",
        },
      },
      buttonForward: "Weiter",
      buttonBack: "Zurück",
      successModal: {
        title: "Dateneingabe",
        body: "Das Hinzufügen von Daten wurde erfolgreich abgeschlossen. Wählen Sie OK zum Fortfahren.",
        buttonOk: "OK",
      },
    },
  };

export interface KatalogEvidencijaResourcesBSInterface {
  deleteModal: {
    title: string;
    text: string;
    buttonYes: string;
    buttonNo: string;
  };
  deleteSuccessModal: {
    title: string;
    body: string;
    buttonOk: string;
  };
  deleteErrorModal: {
    title: string;
    body: string;
    buttonOk: string;
  };
  errors: {
    poslovnica: string;
    katalogEvidencijaBranches: string;
    deleteError: string;
  };
  successModal: {
    title: string;
    body: string;
    buttonOk: string;
  };
  editDescription: {
    title: string;
  };
  addButton: string;
  evidencijePlaceholder: string;
  evidencijeOdabirPoslovnice: string;
  typeEvidencije: {
    occasionally: string;
    redovna: string;
    placeholder: string;
  };
  vrsteEvidencije: {
    evidencija: string;
    template: string;
  };
  evidencijaForm: any;
  autocompleteConfig: any;
  kreiranjeEvidencije: any;
  recordPointsConfig: any;
  frequencyConfig: any;
  usersConfig: any;
  notificationsConfig: any;
  evidenceFieldsConfig: any;
  checklistConfig: ChecklistConfig;
}

interface ChecklistConfig {
  title: string;
  rowLabel: string;
  rowPlaceholder: string;
  fieldLabelPrefix: string;
  checkedByDefaultLabel: string;
  addButton: string;
  removeButton: string;
  buttons: { save: string; back: string };
  errors: { load: string; save: string };
}
